module.exports = __webpack_public_path__ + "img/voucher1.44551fe5.png";